/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 14/2/2022
 */


import BaseObject from "@shared/BaseObject";
import {SortDirection} from "@/core/js/backend/filters/SortDirection";

// export const SortDirection = Object.freeze({
// 	ASC: "asc",
// 	DESC: "desc"
// })

export default class SortOptions extends BaseObject{


	sortOptions = []

	constructor(field, direction = SortDirection.ASC) {
		super();
		if(field){
			this.add(field, direction)
		}
	}

	reset(){
		this.sortOptions = []
		return this;
	}

	add(field, direction){
		this.sortOptions.push({field: field, direction: direction})
		return this
	}

	apply(ref){
		this.sortOptions.forEach(option => {
			console.log("ref = ", ref)
			ref = ref.orderBy(option.field, option.direction)
		})
		return ref;
	}


}



